

export default function ViewPatners() {
    // Section masquée temporairement car il n'y a pas encore de partenaires
    return null;
}